import React from 'react';
import './Offering.css';
import { Helmet } from 'react-helmet-async';



const Gesundheitsfoerderung = () => {
    return (
        <>
            <Helmet>
                <title>Betriebliche Gesundheitsförderung</title>
                <meta name="description" content='Mitarbeiterwertschätzung und -Zufriedenheit steigern durch betriebliche Gesundheitsförderung. Reduzierung von Fehltagen und Fluktuation sowie Steigerung der Leistungsfähigkeit. Mein Angebot umfasst Gesundheitstage mit Themenausstellungen, Ernährungsworkshops für gesunde Pausenmahlzeiten und mehr, Vorträge zu verschiedenen Ernährungsthemen, individuelle Ernährungsberatung für Mitarbeiter, sowie Körperfettmessung.' />
            </Helmet>
            <div className='Foerderung'>
                <div className="BeratungWrapper">
                    <div className='entrycontent'>

                        <h2 className='header'>Betriebliche Gesundheitsförderung</h2>

                        <p className='text'>Eine betriebliche Gesundheitsförderung zeigt den Mitarbeitern Ihres Unternehmens, dass sie wichtig für Ihr Unternehmen sind und trägt dazu bei, dass sie sich wertgeschätzt fühlen.
                            Betriebliche Gesundheitsförderung verbessert nachweislich die Leistungsfähigkeit der Mitarbeiter, hilft Fehltage und Fluktuation zu reduzieren und die Zufriedenheit und Betriebsloyalität zu erhöhen.
                            Gerne unterstütze ich Sie hierbei.
                        </p>
                        <br />
                        <p className='text'>Mein Angebot:</p>
                        <ul>

                            <li className='listentry'>Gesundheitstage
                                <ul>
                                    <li className='listentry'>z.B. Themenausstellung zu Zucker, Fett, Getränken, Brainfood,Messung 	Körperzusammensetzung</li>


                                </ul>
                            </li>
                            <li className='listentry'>Ernährungsworkshops
                                <ul>
                                    <li className='listentry'>z.B. gesunde Pausenmahlzeiten, Power durch richtige Ernährung, Richtig Trinken, schnelle Pausensnacks</li>


                                </ul>
                            </li>
                            <li className='listentry'>Vorträge
                                <ul>
                                    <li className='listentry'>Verschiedene Ernährungsthemen</li>


                                </ul>
                            </li>
                            <li className='listentry'>Individuelle Ernährungsberatung für Ihre Mitarbeiter
                                <ul>
                                    <li className='listentry'>Teilnahmelisten Erstellung durch Personalbüro, ca. 20 Minuten je Mitarbeiter</li>


                                </ul>
                            </li>
                            <li className='listentry'>Körperfettmessung

                            </li>
                        </ul>
                    </div>

                </div >

            </div>
        </>);
}

export default Gesundheitsfoerderung;